module.exports = __webpack_public_path__ + "static/media/11NEPAD1.92919240.jpg";